/* ============================================================
   KOLMAX — Spray Alivio Psoriasis (slug 'kolmax').
   Cargado por layout/landing.liquid (case 'kolmax').
   Bloques: carrusel antes/después · galería de thumbnails · selección de
   bundle (.kx-bundle) · disparo del modal Releasit COD.
   Patrón Releasit (per-unit + quantity): cada bundle = 1 variante con precio
   POR UNIDAD; mandamos quantity = N (unidades) para que el pedido lleve las
   unidades reales (Dropi) y el total quede en el precio del bundle. Releasit
   lee input[name="quantity"] del DOM al disparar. NO usar _rsiV2.setState como
   primer path — el click nativo del botón Releasit SÍ re-lee productData.
   Ver memory/project_bundles_as_variants.
   ============================================================ */

/* ---------- dots del carrusel antes/después ---------- */
(function () {
  var t = document.getElementById('baTrack');
  if (!t) return;
  var dots = t.parentElement.querySelectorAll('.kx-dot');
  t.addEventListener('scroll', function () {
    var p = t.scrollLeft / (t.scrollWidth - t.clientWidth);
    var i = p < .5 ? 0 : 1;
    dots.forEach(function (d, k) { d.classList.toggle('on', k === i); });
  });
})();

/* ---------- galería buy-box: thumb cambia principal ---------- */
(function () {
  var thumbs = document.querySelectorAll('.kx-thumbs .kx-imgbox');
  var main = document.querySelector('.kx-gallery .main img.xs-gen');
  thumbs.forEach(function (th) {
    th.addEventListener('click', function () {
      thumbs.forEach(function (x) { x.classList.remove('on'); });
      th.classList.add('on');
      var img = th.querySelector('img');
      if (img && main) main.src = img.src;
    });
  });
})();

/* ============================================================
   Releasit COD trigger + selección de bundle
   ============================================================ */
var KOLMAX_RELEASIT_SELECTORS = [
  '#rsi_buy_now_button',
  '.rsi_buy_now_button',
  '._rsi-buy-now-button',
  '._rsi-buy-now-button-app-block-hook button',
  '._rsi-buy-now-button-app-block-hook a',
  '.rsi-btn-skel'
];

function kolmaxFindReleasitButton() {
  for (var i = 0; i < KOLMAX_RELEASIT_SELECTORS.length; i++) {
    var el = document.querySelector(KOLMAX_RELEASIT_SELECTORS[i]);
    if (el) return el;
  }
  return null;
}

var kolmaxSelectedVariantId = null;
var kolmaxSelectedQty = 1;

// Cada bundle = una variante con precio POR UNIDAD; mandamos la cantidad real
// (1/2/3 unidades) para que el pedido llegue con las unidades exactas (Dropi
// envía la cantidad) y el total quede en el precio del bundle. Releasit lee el
// input[name="quantity"] del DOM al disparar COD.
function kolmaxSetVariantOnAllForms(variantId, qty) {
  if (!variantId) return;
  var q = parseInt(qty, 10);
  if (!q || q < 1) q = 1;
  document.querySelectorAll('form[action="/cart/add"] input[name="id"]').forEach(function (input) {
    input.value = variantId;
  });
  document.querySelectorAll('input[name="product-id"]').forEach(function (input) {
    input.value = variantId;
  });
  document.querySelectorAll('input[name="quantity"]').forEach(function (input) {
    input.value = String(q);
    input.setAttribute('value', String(q));
  });
  if (window.productData) { window.productData.quantity = q; }
  if (window.productData && Array.isArray(window.productData.variants)) {
    var v = window.productData.variants.find(function (x) { return String(x.id) === String(variantId); });
    if (v) {
      window.productData.selected_or_first_available_variant = v;
      window.productData.selected_variant = v;
      try {
        document.dispatchEvent(new CustomEvent('variant:change', { detail: { variant: v } }));
        document.dispatchEvent(new CustomEvent('product:variant-change', { detail: { variant: v } }));
      } catch (e) {}
    }
  }
}

function kolmaxBundleQty(el) {
  var q = parseInt(el.getAttribute('data-bundle-qty'), 10);
  if (!q) { q = parseInt(el.getAttribute('data-units'), 10); }
  return q || 1;
}

/* ---------- Selección de bundle ---------- */
var kxBundles = document.querySelectorAll('.kx-bundle');

function kxSelectBundle(b) {
  kxBundles.forEach(function (x) { x.classList.remove('on'); });
  b.classList.add('on');
  var id = b.getAttribute('data-bundle-variant-id');
  if (id) {
    kolmaxSelectedVariantId = id;
    kolmaxSelectedQty = kolmaxBundleQty(b);
    kolmaxSetVariantOnAllForms(id, kolmaxSelectedQty);
  }
}

kxBundles.forEach(function (b) {
  b.addEventListener('click', function (e) { e.preventDefault(); kxSelectBundle(b); });
});

function kolmaxTriggerCOD(btn) {
  var variantId = (btn && btn.getAttribute && btn.getAttribute('data-bundle-variant-id')) || kolmaxSelectedVariantId;
  var qty = (btn && btn.getAttribute && btn.getAttribute('data-bundle-qty')) || kolmaxSelectedQty;
  if (variantId) kolmaxSetVariantOnAllForms(variantId, qty);
  setTimeout(function () {
    var releasitBtn = kolmaxFindReleasitButton();
    if (releasitBtn) { releasitBtn.click(); return; }
    var attempts = 0;
    var poll = setInterval(function () {
      attempts++;
      var b = kolmaxFindReleasitButton();
      if (b) { clearInterval(poll); b.click(); return; }
      if (attempts > 30) {
        clearInterval(poll);
        if (window._rsiV2 && typeof window._rsiV2.setState === 'function') {
          try { window._rsiV2.setState({ isOpen: true }); } catch (e) {}
        }
      }
    }, 100);
  }, 50);
}
window.kolmaxTriggerCOD = kolmaxTriggerCOD;

/* ---------- Init: bundle preseleccionado (.on o el primero) ---------- */
(function () {
  var active = document.querySelector('.kx-bundle.on') || document.querySelector('.kx-bundle');
  if (active) kxSelectBundle(active);
})();
